import type { FaireProductEntity } from "../../entity_types/product";

export const p_m9r86vw7rf: FaireProductEntity = {
  token: "p_m9r86vw7rf",
  type: "product",
  name: 'Small Bud Vase-Moss Green-3 Assorted-3"H',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/6a1333040c353cd88ae45e88f2b5111e2bad654c69a22ec35f5de1a7f85daf02.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b3e5572195ff30de9daf0af5838abdfe6d09ec92e71923c81ebe747615d4dc09.png",
    "https://cdn.faire.com/fastly/61d3b2d9107d2c17543352944a81bc9d539770d06e9670fc53cacd988624488d.jpeg",
    "https://cdn.faire.com/fastly/e4b2a4d84146a2d32bccd99fed89935aa751218c1c12a9771eb1b5980f7effeb.jpeg",
    "https://cdn.faire.com/fastly/45b8508f7ee4d0a3717f2cf6172a1a39da052c662b071aa63f99f9408ce5e313.jpeg",
  ],
  priceDollars: 3.5,
  description:
    "Introducing our Small Bud Vases, in dark and moody moss green, adding a pop of personality and style to your home decor. Made from high-quality glass, in 3 shapes, that beautifully showcase single blooms or small arrangements. Whether displayed individually or in a group, this artfully crafted colored glass bud vase brings beauty and sophistication to any space. Additional shapes and colours are available. Each assortment contains 3 different shapes. Price per item.",
  tags: [],
  msrpDollars: 7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:09.337Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
